import { render, staticRenderFns } from "./viewAsideRight.vue?vue&type=template&id=48ab1ae5&"
import script from "./viewAsideRight.vue?vue&type=script&lang=js&"
export * from "./viewAsideRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports